module.exports = __webpack_public_path__ + "media/alaska/weather_stone-5eaa11b1.jpg";